import {BaseApi} from './base-api';
import Vue from 'vue';

export class UserApi extends BaseApi {
  static apiUri = 'users';

  /** @return {Promise<EntityHttpResponse<UserDto>>} */
  static getById (id) {
    return super.getById(id);
  }

  /** @return {Promise<EntityHttpResponse<UserSettingsDto>>} */
  static getUserSettings () {
    return Vue.http.get(this.apiUri + '/settings');
  }

  /** @return {Promise<EntityHttpResponse<EmailSettingsDto>>} */
  static getEmailSettings () {
    return Vue.http.get(this.apiUri + '/email-settings');
  }

  /**
   * @return {Promise<HttpResponse>}
   * @param {UserSaveRequest} userSaveRequest
   **/
  static createUser (userSaveRequest) {
    return Vue.http.post(this.apiUri, userSaveRequest);
  }

  /**
   * @return {Promise<HttpResponse>}
   * @param {number} userId
   * @param {UserSaveRequest} userSaveRequest
   **/
  static updateUser (userId, userSaveRequest) {
    return Vue.http.post(this.apiUri + '/' + userId, userSaveRequest);
  }

  /**
   * @return {Promise<HttpResponse>}
   * @param {UserSettingsDto} userSettings
   **/
  static saveUserSettings (userSettings) {
    return Vue.http.post(this.apiUri + '/settings', userSettings);
  }

  /**
   * @return {Promise<HttpResponse>}
   * @param {ImpersonateRequest} impersonateRequest
   **/
  static impersonateUser (impersonateRequest) {
    return Vue.http.post('auth/impersonate', impersonateRequest);
  }
}
